import Header from "./components/Header";
import Lotrinh from "./components/lotrinh/Lotrinh";
import styled from "styled-components";

import imgBG from "./assets/BG2jpg.jpeg";
import Videoclip from "./components/videoclip/Videoclip";
import Gallery from "./components/gallery/Gallery";

function App() {
    return (
        <>
            <Header />
            <Container>
                <Lotrinh />
                <Videoclip />
                <Gallery />
            </Container>
            <Footer>©2018 All rights reserved HTVC</Footer>
        </>
    );
}
const Container = styled.div`
    width: 1170px;
    margin: 0 auto;
    padding: 0;
    position: relative;
    background: url(${imgBG});
    background-repeat: repeat-y;
    @media only screen and (max-width: 767px) {
        width: 100%;
    }
`;
const Footer = styled.footer`
    text-align: center;
    color: white;
    font-size: 1.5rem;
`;

export default App;
